import Topnavbar from "../../../Layouts/Topnavbar";
import { Container, Grid, Paper, Text, Title, Group, ThemeIcon, Button} from "@mantine/core";
import React, { useState } from "react";
import {
    Table,
    Tag,
    Typography,
    Row,
    Col,
    DatePicker,
    Select,
    Input,
    Space,
    Card,
    Dropdown,
} from "antd";
import { MoreOutlined } from "@ant-design/icons";
const { Search } = Input;
const { RangePicker } = DatePicker;

const initialData = [
    {
        key: 1,
        requestId: "REQ100001",
        status: "Success",
        mode: "IMPS",
        utr: "UTR987654321",
        amount: 5000,
        fee: 10,
        netAmount: 4990,
        date: "24-Jun-2025 10:20 AM",
        remarks: "Amount Credited",
    },
    {
        key: 2,
        requestId: "REQ100002",
        status: "Pending",
        mode: "NEFT",
        utr: "UTR987654322",
        amount: 10000,
        fee: 20,
        netAmount: 9980,
        date: "24-Jun-2025 11:30 AM",
        remarks: "Processing",
    },
    {
        key: 3,
        requestId: "REQ100003",
        status: "Failed",
        mode: "RTGS",
        utr: "UTR987654323",
        amount: 2500,
        fee: 0,
        netAmount: 2500,
        date: "24-Jun-2025 01:15 PM",
        remarks: "Account Invalid",
    },
    {
        key: 4,
        requestId: "REQ100004",
        status: "Success",
        mode: "IMPS",
        utr: "UTR987654324",
        amount: 15000,
        fee: 25,
        netAmount: 14975,
        date: "25-Jun-2025 09:40 AM",
        remarks: "Completed",
    },
];



const Disttrxnreports = ({ Headername }) => {
    const [status, setStatus] = useState("all");
    const [utr, setUtr] = useState("");
    const [data, setData] = useState(initialData);

    const handleSearch = () => {
        let filtered = initialData;

        if (status !== "all") {
            filtered = filtered.filter(
                (item) => item.status.toLowerCase() === status
            );
        }

        if (utr) {
            filtered = filtered.filter((item) =>
                item.utr.toLowerCase().includes(utr.toLowerCase())
            );
        }

        setData(filtered);
    };

    const handleReset = () => {
        setStatus("all");
        setUtr("");
        setData(initialData);
    };

    const columns = [
        {
            title: "S.No.",
            dataIndex: "sno",
            width: 120,
        },
        {
            title: "TXN. ID",
            dataIndex: "requestId",
            width: 120,
        },



        {
            title: "Action",
            dataIndex: "requestId",
            width: 120,
            render: (_, record) => {
                const items = [
                    {
                        key: "1",
                        label: "Print",
                    },
                    {
                        key: "2",
                        label: "Update Status",
                    },
                    // {
                    //     key: "3",
                    //     label: "Refund Request",
                    // },
                ];

                return (
                    <Dropdown
                        menu={{
                            items,
                            onClick: ({ key }) => {
                                switch (key) {
                                    case "1":
                                        console.log("Print", record);
                                        break;
                                    case "2":
                                        console.log("Update Status", record);
                                        break;
                                    // case "3":
                                    //     console.log("Refund", record);
                                    //     break;
                                    default:
                                        break;
                                }
                            },
                        }}
                        trigger={["click"]}
                    >
                        <Button variant="transparent" size="xs">Select Action </Button>
                    </Dropdown>
                );
            },
        },
        {
            title: "Date & Time",
            dataIndex: "datetime",
            width: 120,
        },
        {
            title: "Status",
            dataIndex: "status",
            width: 120,
            render: (status) => {
                let color = "default";

                if (status === "Success") color = "green";
                if (status === "Pending") color = "orange";
                if (status === "Failed") color = "red";

                return <Tag color={color}>{status}</Tag>;
            },
        },
        {
            title: "Service Type",
            dataIndex: "servicetype",
            width: 100,
        },
        {
            title: "TXN Details",
            dataIndex: "txndetails",
            width: 180,
            // render: (utr) => <Text copyable>{utr}</Text>,
        },
        {
            title: "Amount",
            dataIndex: "amount",
            // align: "right",
            // render: (amount) => `₹ ${amount.toLocaleString()}`,
        },
        {
            title: "Fee",
            dataIndex: "fee",
            // align: "right",
            // render: (fee) => `₹ ${fee}`,
        },
        {
            title: "Net Amount",
            dataIndex: "netamount",
            // align: "right",
            // render: (net) => (
            //     <Text strong style={{ color: "#1677ff" }}>
            //         ₹ {net.toLocaleString()}
            //     </Text>
            // ),
        },
        {
            title: "Reference No.",
            dataIndex: "referenceno",
            width: 180,
        },
        {
            title: "Remarks",
            dataIndex: "remarks",
            width: 180,
        },
    ];
    return (
        <>
            <Topnavbar Headername={Headername} />
            <Container size={'xl'} mt={'sm'}>
                <Title c={'dimmed'}>Transaction Reports</Title>
                <Text size="xs">Verify your transaction in transaction reports</Text>
            </Container>

            <Container size={'lg'} mt={'lg'}>
                <Card title="Transaction History" style={{
                    width: "100%",
                }}>
                    <Row gutter={[16, 16]} style={{ marginBottom: 20 }}>
                        <Col xs={24} md={8}>
                            <RangePicker style={{ width: "100%" }} />
                        </Col>
                        <Col xs={24} md={4}>
                            <Select

                                // value={status}
                                // onChange={setStatus}
                                style={{ width: "100%" }}
                                options={[
                                    { label: "Service Type", value: "all" },
                                    { label: "Payout", value: "payout" },
                                    { label: "Aeps", value: "aesp" },
                                    { label: "Recharge", value: "recharge" },
                                    // { label: "Failed", value: "failed" },
                                ]}
                            />
                        </Col>
                        <Col xs={24} md={4}>
                            <Select
                                value={status}
                                onChange={setStatus}
                                style={{ width: "100%" }}
                                options={[
                                    { label: "All Status", value: "all" },
                                    { label: "Success", value: "success" },
                                    { label: "Failed", value: "failed" },
                                    { label: "Refunded", value: "refund" },
                                    { label: "Pending", value: "pending" },
                                    // { label: "Failed", value: "failed" },
                                ]}
                            />
                        </Col>

                        <Col xs={24} md={6}>
                            <Search
                                placeholder="Search Transaction ID"
                                allowClear
                                value={utr}
                            // onChange={(e) => setUtr(e.target.value)}
                            // onSearch={handleSearch}
                            />
                        </Col>

                        <Col xs={24} md={6}>
                            <Space>
                                <Button type="primary">
                                    Search
                                </Button>
                                <Button variant="light">Reset</Button>
                                <Button type="secondary" variant="outline">
                                    Download
                                </Button>
                            </Space>
                        </Col>
                    </Row>

                    <div style={{ width: "100%", overflowX: "auto" }}>
                        <Table
                            columns={columns}
                            dataSource={data}
                            bordered
                            size="middle"
                            pagination={{
                                pageSize: 10,
                                showSizeChanger: true,
                            }}
                        // scroll={{ x: 1200 }}
                        />
                    </div>
                </Card>
            </Container>
        </>
    )
}
export default Disttrxnreports;